import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api.js";
import type { TenantTheme, MainSiteConfig } from "@templestay/db";

type TenantCurrentResponse = {
  tenantId: string | null;
  tenantSlug: string | null;
  name: Record<string, string> | null;
  theme: TenantTheme | null;
  mainSiteConfig: MainSiteConfig | null;
};

type TenantContext = {
  tenantId: string | null;
  tenantSlug: string | null;
  tenantName: Record<string, string> | null;
  tenantTheme: TenantTheme | null;
  mainSiteConfig: MainSiteConfig | null;
  isLoading: boolean;
};

export function useTenantContext(): TenantContext {
  const { data, isLoading } = useQuery({
    queryKey: ["tenant-context"],
    queryFn: () => api.get<TenantCurrentResponse>("/api/tenants/current"),
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });

  return {
    tenantId: data?.tenantId ?? null,
    tenantSlug: data?.tenantSlug ?? null,
    tenantName: data?.name ?? null,
    tenantTheme: data?.theme ?? null,
    mainSiteConfig: data?.mainSiteConfig ?? null,
    isLoading,
  };
}
